import React from 'react';
import PropTypes from 'prop-types';
import { LuxonUtils } from '@js/utils/utils-imports.es6';
import { MidnightVideoCameraIcon } from '@src/images/image-imports';

/**
 * Renders a single appointment time slot.
 */
const Slot = ({ slot, durationMins, visitTypes, accessibility, provider, insuranceRequirement, referralRequirement, appointmentNotesRequired, hasTelemedicine }) => {
  const jsDate = new Date(slot);
  const timeDisplay = LuxonUtils.getSimpleTimeString(jsDate);

  return (
    <span
      className={'day__time-block slot-set ' + (hasTelemedicine && 'telemedicine-slot')}
      data-timeslot={slot}
      data-durationmins={durationMins}
      data-visittypes={JSON.stringify(visitTypes)}
      data-accessibility={accessibility}
      data-providerid={provider}
      data-insurancerequirement={insuranceRequirement}
      data-referralrequirement={referralRequirement}
      data-appointmentnotesrequired={appointmentNotesRequired}
      data-hastelemedicine={hasTelemedicine}
      tabIndex='0'
    >
      {
        hasTelemedicine &&
        <span className='telehealth__icon'>
          <MidnightVideoCameraIcon />
        </span>
      }
      {timeDisplay}
    </span>
  );
}

Slot.propTypes = {
  /**
   * the datetime string for the appointment slot
   */
  slot: PropTypes.string.isRequired,
  /**
   * the duration, in minutes, of the appointment slot
   */
  durationMins: PropTypes.number.isRequired,
  /**
   * the visit types associated with the appointment slot
   */
  visitTypes: PropTypes.array.isRequired,
  /**
   * whether or not the appointment can be booked by authenticated patients (direct or open)
   */
  accessibility: PropTypes.string.isRequired,
  /**
   * the Epic provider ID associated with the appointment slot
   */
  provider: PropTypes.string,
  /**
   * the insurance requirement associated with the appointment slot (none, online)
   */
  insuranceRequirement: PropTypes.string.isRequired,
  /**
   * the referral requirement associated with the appointment slot (none, online, check in)
   */
  referralRequirement: PropTypes.string.isRequired,
  /**
   * whether or not the appointment slot offers telemedicine
   */
  hasTelemedicine: PropTypes.bool.isRequired,
};

export default Slot;
